export const onLogout = () => {
  for (const element of ['t', 'exp_at']) {
    localStorage.removeItem(element);
  }
};
